module.exports = {
  siteTitle: 'Pckitup', // <title>
  manifestName: '',
  manifestShortName: 'Landing', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  heading: 'More people, more transactions, more trash!',
  subHeading: '',

  // social
  socialLinks: [
    {
      icon: 'fa-facebook-f',
      name: 'Facebook',
      url: 'https://goole.com',
    },
    {
      icon: 'fa-twitter',
      name: 'Twitter',
      url: 'https://goole.com',
    },
    {
      icon: 'fa-youtube',
      name: 'Github',
      url: 'https://goole.com',
    },
    {
      icon: 'fa-instagram',
      name: 'Linkedin',
      url: 'https://goole.com/',
    },
  ],
  email: 'test@gmail.com',
  phone: '000-00000',
  address: '305 Del Sol, Sunnyvale, CA',
};
